// src/pages/dashboard/admin/settings/AppSettings.jsx
import { useState, useEffect } from 'react';
import api from '../../../../lib/api';
import LoadingSpinner from '../../../../components/common/LoadingSpinner';
import { success, error } from '../../../../components/common/Toast';
import { ToggleLeft, ToggleRight } from 'lucide-react';

export default function AppSettings() {
  const [settings, setSettings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const res = await api.get('/admin/app-settings');
      setSettings(res.data.data || []);
    } catch {
      error('Failed to load settings');
    } finally {
      setLoading(false);
    }
  };

  const toggle = async (key, current) => {
    try {
      await api.post('/admin/app-settings/toggle', { key, value: !current });
      setSettings(prev => prev.map(s => s.key === key ? { ...s, value: !current } : s));
      success('Setting updated');
    } catch {
      error('Update failed');
    }
  };

  if (loading) return <LoadingSpinner size="lg" />;

  return (
    <div className="max-w-4xl mx-auto py-12 px-6">
      <h1 className="text-5xl font-black text-center mb-16">App Settings</h1>

      <div className="space-y-8">
        {settings.map((s) => (
          <div key={s.key} className="bg-white rounded-3xl shadow-xl p-8 flex items-center justify-between">
            <div>
              <h3 className="text-3xl font-bold capitalize">
                {s.key.replace(/_/g, ' ')}
              </h3>
            </div>
            <button
              onClick={() => toggle(s.key, s.value)}
              className={`relative w-32 h-20 rounded-full transition-all ${s.value ? 'bg-green-500' : 'bg-gray-300'}`}
            >
              <div className={`absolute top-3 left-3 w- w-14 h-14 bg-white rounded-full shadow transition-all ${s.value ? 'translate-x-12' : ''}`}>
                {s.value ? <ToggleRight size={36} className="text-green-600" /> : <ToggleLeft size={36} className="text-gray-600" />}
              </div>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}